(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/results.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/results.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.Results = Marionette.View.extend({
    className: 'view-results results',

    template: function(data) {
      return svs.matchen.templates.results(data);
    },

    regions: {
      home: '.region-home',
      draw: '.region-draw',
      away: '.region-away'
    },

    onRender: function() {
      var results = this.collection;
      var resultsOptions = {
        appendEmptyResults: true,
        maxNumberOfResults: results.getMaxNumberOfResults()
      };

      this.showChildView(
        'home',
        new svs.matchen.views.TeamResults(_.extend(
          { collection: new Backbone.Collection(results.getHomeResults()) },
          resultsOptions
        ))
      );
      this.showChildView(
        'draw',
        new svs.matchen.views.TeamResults(_.extend(
          { collection: new Backbone.Collection(results.getDrawResults()) },
          resultsOptions
        ))
      );
      this.showChildView(
        'away',
        new svs.matchen.views.TeamResults(_.extend(
          { collection: new Backbone.Collection(results.getAwayResults()) },
          resultsOptions
        ))
      );
    }
  });
})(Backbone, _, svs);


 })(window);